
// User Links Desktop 
export const menuListDesktop = [
    {
        title: 'Home',
        link: '/',
    },
    {
        title: 'About US',
        link: '/about',
    },
    {
        title: 'Our Products',
        link: '/products',
        subMenu: [
            {
                title: 'Organic fertilizers',
                subMenu: [
                    { title: 'Organic Liquid Fertilizer', link: '/products/organic-liquid-fertilizer' },
                    { title: 'Bio based Organic solid Fertilizer', link: '/products/bio-based-organic-solid-fertilizer' },
                    { title: 'Organic Active Capsule Fertilizer', link: '/products/organic-active-capsule-fertilizer' },
                ]
            },
            {
                title: 'Construction Chemicals',
                subMenu: [
                    { title: 'Concrete Bonding Powder', link: '/products/concrete-bonding-powder' },
                    { title: 'Nano technology based Water proofing Chemical', link: '/products/nano-technology-based-water-proofing-chemical' },
                ]
            },
            {
                title: 'Regular Cleaning Agents',
                subMenu: [
                    { title: 'Floor Cleaner', link: '/products/floor-cleaner' },
                    { title: 'Dishwasher Gel', link: '/products/dishwasher-gel' },
                    { title: 'Textile Washing Matic Liquid', link: '/products/textile-washing-matic-liquid' },
                    { title: 'Glass and surface Cleaner', link: '/products/glass-and-surface-cleaner' },
                    { title: 'Car Foam Wash Cleaner', link: '/products/car-foam-wash-cleaner' },
                ]
            },
            {
                title: 'Custom Cleaning agent',
                subMenu: [
                    { title: 'Rust cleaner', link: '/products/rust-cleaner' },
                    { title: 'Oxidation cleaner', link: '/products/oxidation-cleaner' },
                    { title: 'Custom Floor Cleaner', link: '/products/custom-floor-cleaner' },
                    { title: 'Custom Profile Cleaner', link: '/products/custom-profile-cleaner' },
                ]
            },
        ]
    },
    {
        title: 'Media',
        link: '/media',
    },
    {
        title: 'Contact Us',
        link: '/contact',
    },
]

// User Links Mobile  
export const menuListMobile = [
    {
        title: 'Home',
        link: '/',
    },
    {
        title: 'About US',
        link: '/about',
    },
    {
        title: 'Our Products',
        // link: '/products',
        subMenu: [
            {
                title: 'Organic fertilizers',
                subMenu: [
                    { title: 'Organic Liquid Fertilizer', link: '/products/organic-liquid-fertilizer' },
                    { title: 'Bio based Organic solid Fertilizer', link: '/products/bio-based-organic-solid-fertilizer' },
                    { title: 'Organic Active Capsule Fertilizer', link: '/products/organic-active-capsule-fertilizer' },
                ]
            },
            {
                title: 'Construction Chemicals',
                subMenu: [
                    { title: 'Concrete Bonding Powder', link: '/products/concrete-bonding-powder' },
                    { title: 'Nano technology based Water proofing Chemical', link: '/products' },
                ]
            },
            {
                title: 'Regular Cleaning Agents',
                subMenu: [
                    { title: 'Floor Cleaner', link: '/products/floor-cleaner' },
                    { title: 'Dishwasher Gel', link: '/products/dishwasher-gel' },
                    { title: 'Textile Washing Matic Liquid', link: '/products/textile-washing-matic-liquid' },
                    { title: 'Glass and surface Cleaner', link: '/products/glass-and-surface-cleaner' },
                ]
            },
            {
                title: 'Custom Cleaning agent',
                subMenu: [
                    { title: 'Rust cleaner', link: '/products/rust-cleaner' },
                    { title: 'Oxidation cleaner', link: '/products/oxidation-cleaner' },
                    { title: 'Custom Floor Cleaner', link: '/products/custom-floor-cleaner' },
                    { title: 'Custom profile Cleaner', link: '/products/custom-profile-cleaner' },
                ]
            },
        ]
    },
    {
        title: 'Media',
        link: '/media',
    },
    {
        title: 'Contact Us',
        link: '/contact',
    },
]


// Admin Links 
export const adminLinks = [
    {
        title: 'Slider',
        link: '/admin/dashboard?tab=slider',
    },
    {
        title: 'Offer',
        link: '/admin/dashboard?tab=offer',
    },

]


